export const isLengthBetween = (min, max) => (value) => {
  if (value && (`${value}`.length < min || `${value}`.length > max)) {
    return `Must be ${min}-${max} characters`;
  }
  return undefined;
};

export default isLengthBetween;
